module.exports = __webpack_public_path__ + "img/iniciar-sesion.a4d9fdc4.png";